
import React from "react";
import { Link } from "react-router-dom";
import type { Guide } from "@/types/guide";
import { Card } from "@/components/ui/card";
import { useLanguage } from "@/context/LanguageContext";

interface GuideCardProps {
  guide: Guide;
}

const GuideCard = ({ guide }: GuideCardProps) => {
  const { language } = useLanguage();
  
  // Display the title and summary based on language
  const getTitle = () => {
    if (language === 'en' && guide.title_en) return guide.title_en;
    return guide.title;
  };

  const getSummary = () => {
    if (language === 'en' && guide.summary_en) return guide.summary_en;
    return guide.summary;
  };

  return (
    <Link to={`/guides/${guide.id}`}>
      <Card className="overflow-hidden h-full transition-all duration-200 hover:shadow-md hover:-translate-y-1">
        <div className="aspect-video w-full overflow-hidden bg-muted">
          <img
            src={guide.cover_image_url || "https://source.unsplash.com/random/800x600?rental"}
            alt={getTitle()}
            className="object-cover w-full h-full"
          />
        </div>
        <div className="p-4">
          <div className="text-sm text-muted-foreground mb-2">
            {new Date(guide.created_at).toLocaleDateString(language === 'en' ? 'en-CA' : 'zh-TW')}
          </div>
          <h3 className="font-semibold text-lg mb-2 line-clamp-2 group-hover:text-primary">
            {getTitle()}
          </h3>
          <p className="text-muted-foreground text-base line-clamp-2">
            {getSummary()}
          </p>
        </div>
      </Card>
    </Link>
  );
};

export default GuideCard;
